import { useEffect } from 'react'

import useLocalStorage from './useLocalStorage'

const useColorMode = () => {
  const [colorMode, setColorMode] = useLocalStorage('color-theme', 'light')

  useEffect(() => {
    const className = 'dark'
    const html = window.document.documentElement.classList

    if (colorMode === 'dark') {
      html.add(className)
    } else {
      html.remove(className)
    }
  }, [colorMode])

  return [colorMode, setColorMode]
}

export default useColorMode
